// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.print-container {
    background: white;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    margin: 2rem auto;
    max-width: 210mm;
    padding: 2rem;
}

@media print {
    .print-container {
        box-shadow: none;
        margin: 0;
        padding: 0;
    }

    .no-print {
        display: none !important;
    }
}

.form-header {
    border-bottom: 2px solid #e5e7eb;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
}

.form-section {
    margin-bottom: 2rem;
}


.form-footer {
    border-top: 2px solid #e5e7eb;
    margin-top: 2rem;
    padding-top: 1rem;
    text-align: center;
}

.print-button {
    background-color: #2563eb;
    border-radius: 0.375rem;
    color: white;
    font-weight: 500;
    padding: 0.5rem 1rem;
    transition: background-color 150ms;
}

.print-button:hover {
    background-color: #1d4ed8;
}

.download-button {
    background-color: #059669;
    border-radius: 0.375rem;
    color: white;
    font-weight: 500;
    padding: 0.5rem 1rem;
    transition: background-color 150ms;
}

.download-button:hover {
    background-color: #047857;
} `, "",{"version":3,"sources":["webpack://./src/Components/style/form.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,4EAA4E;IAC5E,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,SAAS;QACT,UAAU;IACd;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".print-container {\n    background: white;\n    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    margin: 2rem auto;\n    max-width: 210mm;\n    padding: 2rem;\n}\n\n@media print {\n    .print-container {\n        box-shadow: none;\n        margin: 0;\n        padding: 0;\n    }\n\n    .no-print {\n        display: none !important;\n    }\n}\n\n.form-header {\n    border-bottom: 2px solid #e5e7eb;\n    margin-bottom: 2rem;\n    padding-bottom: 1rem;\n}\n\n.form-section {\n    margin-bottom: 2rem;\n}\n\n\n.form-footer {\n    border-top: 2px solid #e5e7eb;\n    margin-top: 2rem;\n    padding-top: 1rem;\n    text-align: center;\n}\n\n.print-button {\n    background-color: #2563eb;\n    border-radius: 0.375rem;\n    color: white;\n    font-weight: 500;\n    padding: 0.5rem 1rem;\n    transition: background-color 150ms;\n}\n\n.print-button:hover {\n    background-color: #1d4ed8;\n}\n\n.download-button {\n    background-color: #059669;\n    border-radius: 0.375rem;\n    color: white;\n    font-weight: 500;\n    padding: 0.5rem 1rem;\n    transition: background-color 150ms;\n}\n\n.download-button:hover {\n    background-color: #047857;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
